import * as React from 'react'
import { connect } from 'react-redux'
import {
    CardBody,
    Row,
    CardHeader,
    Col,
    Collapse,
    Input,
    Label
} from "reactstrap";
import {WithTranslation, withTranslation} from "react-i18next";
import {CurrencyProps, Language, NATURAL_SORT_COMPARE_OPTIONS} from "App/constants";
import {ConfiguratorProductTypes, Product} from "App/services/api";
import * as ReactMarkdown from "react-markdown";
import {selectedLang} from "App/helper";

interface StateToProps extends CurrencyProps {
    types: Array<ConfiguratorProductTypes>
    product: Product
    chosenType: ConfiguratorProductTypes | undefined;
}

interface DispatchToProps {
    onProductTypeChange: (type: ConfiguratorProductTypes) => void
}

interface ComponentState {
    isVisible: boolean
}

function initialState (props: StateToProps): ComponentState {
    return {
        isVisible: false
    }
}

//const txt = '<table class="descriptiontable">↵ <col class="descriptioncol" width="50%" />\\n <col class="descriptioncol" width="50%" />\\n↵<tr><td colspan="1"></td><td colspan="1"></td></tr>↵↵<tr><td colspan="2"><b class="descriptionb">Technische Hauptdaten:</b></td></tr>↵↵<tr><td colspan="1">Einsatzgewicht:</td><td colspan="1">1\'940 kg</td></tr>↵↵<tr><td colspan="1">Motor:</td><td colspan="1">Yanmar 3-Zylinder (Stufe II)</td></tr>↵↵<tr><td colspan="1">Motorleistung (ISO9249):</td><td colspan="1">17,9 kW / 24,3 PS</td></tr>↵↵<tr><td colspan="1">Fahrwerkslänge:</td><td colspan="1">1\'600 mm</td></tr>↵↵<tr><td colspan="1">Transportbreite:</td><td colspan="1">990 mm</td></tr>↵↵<tr><td colspan="1">Transportlänge:</td><td colspan="1">3\'650 mm</td></tr>↵↵<tr><td colspan="1">Transporthöhe:</td><td colspan="1">2\'290 mm</td></tr>↵↵<tr><td colspan="1">Langer Stiel:</td><td colspan="1">1\'180 mm</td></tr>↵↵<tr><td colspan="1">Max. Grabtiefe:</td><td colspan="1">2\'401 mm</td></tr>↵↵<tr><td colspan="1">Max. Reichweite am Boden:</td><td colspan="1">3\'894 mm</td></tr>↵↵<tr><td colspan="1">Gummiraupen:</td><td colspan="1">230 mm</td></tr>↵↵<tr><td colspan="1"></td><td colspan="1"></td></tr>↵↵<tr><td colspan="2"><b class="descriptionb">Standardlieferumfang:</b></td></tr>↵↵<tr><td colspan="2"><b class="descriptionb">Motor:</b> Yanmar 3-Zylinder, Typ 3TNV76, Stufe II</td></tr>↵↵<tr><td colspan="1"></td><td colspan="1"></td></tr>↵↵<tr><td colspan="2"><b class="descriptionb">Hydraulik:</b> Hydraulische Vorsteuerung mit Verstellpumpe, 2 proportional steuerbare Zusatzhydraulikkreise (Volumenströme einstellbar) für Schwenklöffel, Hydraulikhammer, Abbruch- und Sortiergreifer, etc., Verstellfahrwerk von 990 mm bis 1\'300 mm mit Gummiraupen</td></tr>↵↵<tr><td colspan="1"></td><td colspan="1"></td></tr>↵↵<tr><td colspan="2"><b class="descriptionb">Komfort:</b> Kabine schallisoliert, mit Heizung, Defroster, Radio, 2-teiliger Frontscheibe, Scheibenwischer, Beleuchtung und Rückspiegel, Multifunktionsdisplay (Tankanzeige, Kühlmitteltemperatur, Serviceintervalle, Warn- und Kontrollleuchten), Arbeitsscheinwerfer, Planierschild mit Schwimmstellung, langer Stiel, Maschinenüberwachungssystem Caterpillar Product Link (Datenübertragung ist Kostenpflichtig)</td></tr>↵↵<tr><td colspan="1"></td><td colspan="1"></td></tr>↵↵<tr><td colspan="2"><b class="descriptionb">Sicherheit:</b> Fahrerkabine mit Steinschlagschutz gemäss ISO 10262 (Stufe 1), Umsturzschutz gemäss ISO 12117</td></tr>↵↵<tr><td colspan="1"></td><td colspan="1"></td></tr>↵↵<tr><td colspan="2">Weitere Daten und Optionen finden Sie im Spezifikationsblatt.</td></tr>↵↵<tr><td colspan="1"> </td><td colspan="1"> </td></tr>↵</table><br />';

class _Component extends React.PureComponent<StateToProps & DispatchToProps & WithTranslation, ComponentState> {

    constructor(props: StateToProps & DispatchToProps & WithTranslation, context: any) {
        super(props, context);
        this.state = initialState(props);
    }

    toggleVisibility() {
        this.setState((state, props) => ({
            isVisible: !state.isVisible
        }));
    }

    render() {
        const {i18n, product, types, chosenType, t, onProductTypeChange} = this.props;
        const language: Language = selectedLang(i18n);
        return <React.Fragment>
            <CardHeader id="headingOne" className="px-5 d-flex align-items-center py-3 bg-white toggable" onClick={() => this.toggleVisibility()}>
                <span className="my-0 w-75 float-left title-normal-uppercase py-1">{ t('products.configuration.baseinfo') }</span>
                {
                    chosenType ?
                        <i className={'far fa-lg w-25 text-right ' + (this.state.isVisible ? 'fa-chevron-up' : 'fa-chevron-down')}></i>
                        : null
                }
            </CardHeader>
            <CardBody className="px-5 py-2 bodyslice">
                <Row className="pt-2 no-gutters">
                    <Col className="col-md-4">
                        {product.maincharacteristic1nameml ?
                            <React.Fragment>
                                <div className="title-small-uppercase">{product.maincharacteristic1nameml[language]}</div>
                                <div className="text-large-details">{product.maincharacteristic1value}</div>
                            </React.Fragment>
                            : null
                        }
                    </Col>
                    <Col className="col-md-4">
                        {product.maincharacteristic2nameml ?
                            <React.Fragment>
                                <div className="title-small-uppercase">{product.maincharacteristic2nameml[language]}</div>
                                <div className="text-large-details">{product.maincharacteristic2value}</div>
                            </React.Fragment>
                            : null
                        }
                    </Col>
                    <Col className="col-md-4">
                        {product.maincharacteristic3nameml ?
                            <React.Fragment>
                                <div className="title-small-uppercase">{product.maincharacteristic3nameml[language]}</div>
                                <div className="text-large-details">{product.maincharacteristic3value}</div>
                            </React.Fragment>
                            : null
                        }
                    </Col>
                </Row>
                {
                    types?
                        types.length>1 || !chosenType?
                            types
                                .sort((t1, t2) => (t1.name||'').localeCompare(t2.name||'', undefined, NATURAL_SORT_COMPARE_OPTIONS) ||
                                    (t1.linkagename||'').localeCompare(t2.linkagename||'', undefined, NATURAL_SORT_COMPARE_OPTIONS))
                                .map((type, index) => (
                                <Row key={type.typeid} className="no-gutters">
                                    <Col className="align-self-center py-2">
                                        <div className="form-check">
                                            <Input checked={chosenType&&(type.typeid===chosenType.typeid)} type="radio" id={"typeInput" + type.typeid} name={"typeInput" + type.typeid} className="align-middle" onChange={() => onProductTypeChange(type)}/>
                                            <Label for={"typeInput" + type.typeid} className="align-middle">{type.name}</Label>
                                        </div>
                                    </Col>
                                </Row>)):
                            <Row className="no-gutters">
                                <Col className="align-self-center">
                                    <div className="w-100 text-left pb-2">{chosenType.name}</div>
                                </Col>
                            </Row>
                        :null
                }
                {
                    chosenType ?
                        <React.Fragment>
                            <Collapse isOpen={this.state.isVisible}>
                                <CardBody className="px-3 py-2">
                                    <ReactMarkdown source={(chosenType.descriptionml[language]||'').replace(/(?:\r|\n|\\n|\\r)/g, '')} escapeHtml={false} />
                                </CardBody>
                            </Collapse>
                            <Row className={(chosenType ? '' : 'd-none') + ' no-gutters'}>
                                <Col className="align-self-center pb-3 pt-2">
                                    <div className="action w-100 text-left text-bold-small-details"
                                         onClick={() => this.toggleVisibility()}>
                                        {this.state.isVisible ? t('products.configuration.hidebaseinfo') : t('products.configuration.showbaseinfo')}
                                    </div>
                                </Col>
                            </Row>
                        </React.Fragment>
                        : null
                }
            </CardBody>
        </React.Fragment>
    }
}

export const Component = connect(null, null)(withTranslation('common')(_Component));


// WEBPACK FOOTER //
// ./src/components/BaseConf.tsx